/**
 * @(#)2019/8/15.
 * YxUpload，用于控制上传按钮
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import React from "react";
import Icon from "../../../YxText/Icon";
import YxButton from "../../../YxButton";
import { get, merge } from "../../../../utils";
import { l } from "../../../../config/language";
import { omit } from "lodash";

export default function (uploadProps, uploadObj) {
  const { loading, fileList } = uploadObj;
  const props = { ...uploadProps, loading, fileList };
  /**
   * 能否显示上传按钮条件函数
   *
   * @returns bool
   * @memberof UploadButton
   */
  const uploadButtonConditions = function () {
    const { limit, isRead, fileList, loading } = props;
    const fileLength = get(fileList, "length", 0);
    let conditionList = [
      loading,
      isRead && fileLength > 0,
      !(limit === 0 || fileLength < limit),
    ];
    return !conditionList.some((con) => con);
  };

  const render = function () {
    const { showType, isRead } = props;
    const uploadBtnParam = get(props, "uploadBtnParam", {});
    const param = {
      iconfont: true,
      text: l("YxUpload.cut", uploadObj),
      disabled: isRead,
    };
    const type = showType === "video" ? "imgs" : showType;
    let btnProps = omit(merge(param, uploadBtnParam), "iconfont");
    const jsxDict = {
      text: (
        <YxButton {...btnProps}>
          <Icon type="iconshangchuan" iconfont={true} />
          {l("YxUpload.cutt", uploadObj)}
        </YxButton>
      ),
      imgs: (
        <div>
          <Icon type="icontianjia" iconfont={true} />
          <div className="ant-upload-text">{l("YxUpload.cumt", uploadObj)}</div>
        </div>
      ),
      thumb: (
        <YxButton {...btnProps}>
          <Icon type="upload" /> {l("YxUpload.cutht", uploadObj)}
        </YxButton>
      ),
    };
    const jsx = jsxDict[type];
    return uploadButtonConditions(props) ? jsx : null;
  };

  return render();
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/Components/UploadButton.js